




import Vue from "vue";
import { zoom, zoomIdentity, select, Selection } from "d3";
import { DocumentImage } from "@/types/document/documentImage";
export default Vue.extend({
    name: "ZoomedImage",
    props: {
        image: Object as () => DocumentImage
    },
    mounted() {
        this.initImage();
    },
    methods: {
        initImage(): void {
            const screenWidth = document.body.offsetWidth;
            const screenHeight = document.body.offsetHeight + 10;
            const svg = select("#image").append("svg").attr("width", screenWidth).attr("height", screenHeight);
            const container = svg
                .append("g")
                .classed("container", true)
                .append("image")
                .attr("xlink:href", this.image.source)
                .style("cursor", "move");
            var scale =
                this.image.width === 0 || this.image.height === 0
                    ? 1
                    : screenWidth / this.image.width > screenHeight / this.image.height
                    ? screenWidth / this.image.width
                    : screenHeight / this.image.height;
            const zoomed = zoom()
                .scaleExtent([0.1, 10])
                .on("zoom", e => this.onZoom(container, e)) as any;
            svg.call(zoomed);

            const centered = zoomIdentity
                .translate((screenWidth - this.image.width * scale) / 2, (screenHeight - this.image.height * scale) / 2)
                .scale(scale);
            svg.call(zoomed.transform, centered);
        },
        onZoom(container: Selection<SVGImageElement, any, HTMLElement, any>, event: any): void {
            container.attr("transform", event.transform);
        }
    }
});
